var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.0799 9.09128C8.03323 9.08461 7.97323 9.08461 7.9199 9.09128C6.74657 9.05128 5.81323 8.09128 5.81323 6.91128C5.81323 5.70461 6.78657 4.72461 7.9999 4.72461C9.20657 4.72461 10.1866 5.70461 10.1866 6.91128C10.1799 8.09128 9.25323 9.05128 8.0799 9.09128Z",
  stroke: "black",
  strokeOpacity: 0.85,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4933 13.4913C11.3066 14.578 9.73326 15.238 7.99992 15.238C6.26659 15.238 4.69326 14.578 3.50659 13.4913C3.57326 12.8647 3.97326 12.2513 4.68659 11.7713C6.51326 10.558 9.49992 10.558 11.3133 11.7713C12.0266 12.2513 12.4266 12.8647 12.4933 13.4913Z",
  stroke: "black",
  strokeOpacity: 0.85,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99992 15.2381C11.6818 15.2381 14.6666 12.2534 14.6666 8.57145C14.6666 4.88955 11.6818 1.90479 7.99992 1.90479C4.31802 1.90479 1.33325 4.88955 1.33325 8.57145C1.33325 12.2534 4.31802 15.2381 7.99992 15.2381Z",
  stroke: "black",
  strokeOpacity: 0.85,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgProfileCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.0e05f1f6f51a405287b3d94d04b4b668.svg";
export { ForwardRef as ReactComponent };